import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useNotes() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) => axiosPrivate.post("/v1/notes", parameters).then(parseSuccessResponseData),
        });
    }

    function useList() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.get(`/v1/notes/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.put(`/v1/notes/update`, parameters).then(parseSuccessResponseData),
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (id: string) => axiosPrivate.delete(`/v1/notes/${id}`).then(parseSuccessResponseData),
        });
    }

    return {
        useCreate,
        useList,
        useUpdate,
        useDelete,
    };
}
